export var getSizes = function getSizes(theme, size) {
  var sizes = {
    medium: {
      height: "calc(1.688 * ".concat(theme.layout.gap, ")"),
      fontSize: '.875rem',
      minWidth: '10rem'
    },
    small: {
      height: "calc(1.344 * ".concat(theme.layout.gap, ")"),
      fontSize: '.75rem',
      minWidth: '8rem'
    },
    mini: {
      height: "calc(1 * ".concat(theme.layout.gap, ")"),
      fontSize: '.75rem',
      minWidth: '6.5rem'
    },
    large: {
      height: "calc(2 * ".concat(theme.layout.gap, ")"),
      fontSize: '1.225rem',
      minWidth: '12.5rem'
    }
  };
  return size ? sizes[size] : sizes.medium;
};